import { render } from "./directionComponent.vue?vue&type=template&id=68128d02"
import script from "./directionComponent.vue?vue&type=script&lang=js"
export * from "./directionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__